import { useEffect } from 'react';
import { isOptionsVisible, updateIndexDown, updateIndexUp } from '../utils';

import { KEYS, KEY_VALUES } from '../consts';

const useArrowKeysEvents = ({ index, options, onChange, isMultiple }) => {
  useEffect(() => {
    if (isMultiple) {
      return;
    }

    const callback = (event) => {
      // for full crossbrowserity
      const key = event.key || String(event.keyCode);

      switch (KEY_VALUES[key]) {
        case KEYS.ARROW_UP:
        case KEYS.ARROW_DOWN: {
          if (event.shiftKey || event.metaKey || !isOptionsVisible(options)) {
            return;
          }

          event.preventDefault();

          const nextIdx =
            key === KEYS.ARROW_UP ? updateIndexUp(index, options) : updateIndexDown(index, options);

          onChange(options[nextIdx], { updateActive: true });
          break;
        }
        default:
          break;
      }
    };

    document.addEventListener('keydown', callback, true);
    return () => {
      document.removeEventListener('keydown', callback, true);
    };
  }, [index, options, onChange, isMultiple]);
};

export default useArrowKeysEvents;
